import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const defaultConfig = {
    passwordLength: 6,
    includeLetter: true,
    includeDigit: true,
    lockedEnabled: true,
    maxFailedLockTimes: 5,
    autoUnlockTime: 30,
    useRandomPassword: true,
    accountLoginEnabled: true,
    smsLoginEnabled: false,
};

const initState = {
    isLoading: false,
    isSaving: false,
    config: defaultConfig,
};

const [
    viewModel,
    update, reset,

] = BaseUtil.getViewModel(initState, type);

export {
    update, reset, defaultConfig,
};
export default viewModel;
